<template>
    <div id="top" class="text-center p-1 font-weight-bold">
        <p class="m-0 p-0">VOOR DUMMIES MAKEN ALLES MAKKELIJKER!</p>
    </div>
</template>

<script>
    export default {
        name:'top',
        props:{
        }
    }
</script>

<style scoped> 
   
</style>




// WEBPACK FOOTER //
// src/components/overall_layouts/app-top.vue